export const SET_MOUSE_POSITION = 'SET_MOUSE_POSITION'
export const SET_SCROLL_TOP = 'SET_SCROLL_TOP'
export const SET_GLOBAL_DATA = 'SET_GLOBAL_DATA'

/* PRISMIC DATA */
export const SET_HEADER = 'SET_HEADER'
export const SET_FOOTER = 'SET_FOOTER'
export const SET_HOMEPAGE = 'SET_HOMEPAGE'
export const SET_SERVICES = 'SET_SERVICES'
export const SET_CONTACT = 'SET_CONTACT'
export const SET_LEGALS = 'SET_LEGALS'
